import request from "@/utils/request";

export interface QuestionTypeQuery {
  current?: number;
  size?: number;
  typeCode?: string;
  typeName?: string;
}

export interface QuestionTypeForm {
  id?: number | null;
  typeCode: string;
  typeName: string;
  description?: string;
  sort: number;
}

export function getQuestionTypeList(data: QuestionTypeQuery): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionType/list",
    type: "params",
    data
  });
}

export function getQuestionTypeAllList(data?: { typeName?: string }): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionType/allList",
    type: "params",
    data
  });
}

export function getQuestionTypeDetail(id: number): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionType/get",
    type: "params",
    data: { id }
  });
}

export function addQuestionType(data: QuestionTypeForm): Promise<any> {
  return request({
    method: "PUT",
    url: "manage/questionType/add",
    data
  });
}

export function updateQuestionType(data: QuestionTypeForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionType/update",
    data
  });
}

export function deleteQuestionType(id: number): Promise<any> {
  return request({
    method: "DELETE",
    url: "manage/questionType/delete",
    type: "params",
    data: { id }
  });
}
